import { initialState, SupplierTasksState } from '../state/supplier-tasks.state';
import { SupplierTasksActions } from '../actions/supplier-task.action';

export function SupplierTasksReducer(
    state: SupplierTasksState = initialState,
    action: SupplierTasksActions
): SupplierTasksState {
    switch (action.type) {
        case 'Get_Supplier_Task_Step_State_Success': {
            return {
                ...state,
                supplierTaskStep: action.payload
            };
        }

        default: return state;
    }
}
